import { saveTodaySuggestionForWidget } from './native/widgetSync';

/**
 * Fetch a suggestion from the server and return the JSON.
 */
export async function fetchSuggestion(params: Record<string, any> = {}) {
  const query = new URLSearchParams(params as any).toString();
  const url = '/get_suggestion.php' + (query ? `?${query}` : '');

  const res = await fetch(url, {
    credentials: 'include',
  });

  const data = await res.json();
  if (!res.ok || data.error) {
    throw new Error(data.error || 'Failed to load suggestion');
  }

  return data;
}

/**
 * Take the server response, update your UI, and sync the widget.
 * Call this instead of handling get_suggestion.php inline.
 */
export async function applySuggestion(data: any) {
  // 1. Your existing UI logic (pseudo—replace with your real calls):
  //    - update the card content
  //    - set title, description, etc.

  const card = document.querySelector('[data-suggestion-card]');
  if (card) {
    const titleEl = card.querySelector('[data-suggestion-title]');
    const subtitleEl = card.querySelector('[data-suggestion-subtitle]');

    if (titleEl) {
      titleEl.textContent = data.title || data.name || 'Today’s Trauvo pick';
    }

    if (subtitleEl) {
      subtitleEl.textContent =
        data.short_description ||
        data.location ||
        data.city ||
        '';
    }
  }

  // 2. Sync to widget
  await saveTodaySuggestionForWidget({
    id: data.activity_id ?? data.id ?? 0,
    title: data.title || data.name || 'Today’s Trauvo pick',
    subtitle:
      data.short_description ||
      data.location ||
      data.city ||
      '',
  });
}

/**
 * Convenience helper: fetch + apply in one go.
 */
export async function loadTodaySuggestion(params: Record<string, any> = {}) {
  const data = await fetchSuggestion(params);
  await applySuggestion(data);
  return data;
}
